import { render, staticRenderFns } from "./DiscountSingleCoupon.vue?vue&type=template&id=9481c02a&"
import script from "./DiscountSingleCoupon.vue?vue&type=script&lang=js&"
export * from "./DiscountSingleCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports